module.exports = __webpack_public_path__ + "img/ic_target@2x.2ead9616.png";